// secrets.js - Fetch secrets from the backend API
console.log("✅ secrets.js file loaded!");

export async function getSecrets() {
    try {
      const serverAddress = process.env.REACT_APP_SERVER_ADDRESS

      const response = await fetch(`${serverAddress}/api/secrets`); // `http://127.0.0.1:5000/api/secrets` `${serverAddress}/api/secrets` to run it locally. 

      const data = await response.json();
  
      if (data.error) {
        console.error("Error fetching secrets:", data.error);
        return null;
      }
  
      return data; // Returns all secrets as a JSON object
    } catch (error) {
      console.error("Error fetching secrets:", error);
      return null;
    }
  }
  